/**
 * storage.ts - Firebase Storage 순수 유틸리티 함수
 *
 * React 훅/컨텍스트 의존 없이 Storage 관련 작업 수행
 */

import { ref, getDownloadURL } from 'firebase/storage';
import { storage } from '../../firebase/config';

/**
 * Storage 경로에서 download URL 획득
 *
 * 순수 유틸 함수 - React 훅 사용 금지
 *
 * @param storagePath - Storage 파일 경로 (예: interviewSignatures/company/...)
 * @returns download URL 또는 null (경로 없음/에러 시)
 */
export async function getSignatureUrl(storagePath: string): Promise<string | null> {
  if (!storagePath || !storage) {
    return null;
  }

  try {
    const storageRef = ref(storage, storagePath);
    return await getDownloadURL(storageRef);
  } catch (error: any) {
    // 권한 에러, 404 등 - 콘솔에 경고만 출력
    console.warn('[getSignatureUrl] URL 로드 실패:', storagePath, error?.code || error?.message);
    return null;
  }
}
